import { twMerge } from "@/utils/twMerge";

type Props = {
  title: string;
  icon?: React.ReactNode;
  isActive?: boolean;
};

export function Option({ title, icon, isActive }: Props) {
  return (
    <div
      className={twMerge(
        "relative flex items-center rounded-8 h-[34px] px-2 select-none cursor-pointer hover:bg-suggestion-option-active-bg",
        isActive && "bg-suggestion-option-active-bg",
      )}
    >
      {icon && <div className="mr-2">{icon}</div>}
      <div className={twMerge("text-suggestion-option-text whitespace-nowrap mr-2")}>{title}</div>
    </div>
  );
}
